module.exports = {
  title: '添加品牌商',
  route: {
    path: '/user-manage',
    children: {
      path: 'brand-dealer-add',
    },
  },
};
